import { motion } from "framer-motion";
import { FileDown } from "lucide-react";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "../i18n";

export const Availability = ({ t }) => (
    <section id="download" className="scroll-mt-28 bg-[#F8FAFC] py-24 md:py-32" data-testid="availability-section">
        <div className="mx-auto max-w-[900px] px-6 md:px-12">
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                className="rounded-[2.5rem] border border-[#E2E8F0] bg-white px-8 py-14 text-center shadow-[0_30px_80px_rgba(5,37,54,0.08)] md:px-16 md:py-20"
                data-testid="download-card"
            >
                <p className="text-xs font-bold uppercase tracking-[0.26em] text-[#0D9488] md:text-sm" data-testid="availability-overline">
                    {t.availability.overline}
                </p>
                <h2 className="font-display mt-4 text-4xl leading-tight tracking-tight text-[#0F172A] md:text-5xl" data-testid="availability-title">
                    {t.availability.title}
                </h2>
                <p className="mx-auto mt-5 max-w-lg text-base leading-relaxed text-[#475569] md:text-lg" data-testid="availability-sub">
                    {t.availability.sub}
                </p>

                <div className="mt-10 flex flex-wrap items-center justify-center gap-5" data-testid="download-badges">
                    <a
                        href={APP_STORE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="transition-transform duration-300 hover:-translate-y-1 hover:scale-[1.04]"
                        data-testid="availability-badge-appstore"
                    >
                        <img src="/brand/badge-appstore.png" alt={t.availability.ios} className="h-14 w-auto md:h-16" />
                    </a>
                    <a
                        href={GOOGLE_PLAY_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="transition-transform duration-300 hover:-translate-y-1 hover:scale-[1.04]"
                        data-testid="availability-badge-googleplay"
                    >
                        <img src="/brand/badge-googleplay.png" alt={t.availability.androidBadge} className="h-14 w-auto md:h-16" />
                    </a>
                </div>

                <p className="mt-8 text-xs leading-relaxed text-[#94A3B8] md:text-sm" data-testid="availability-note">
                    {t.availability.note}
                </p>
                <a
                    href="/TheraOffice-Guide-2026.pdf"
                    download="TheraOffice-Guide-2026.pdf"
                    className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-[#0D9488] transition-colors duration-300 hover:text-[#0E4B57]"
                    data-testid="guide-download-button"
                >
                    <FileDown size={16} />
                    {t.availability.guide}
                </a>
            </motion.div>
        </div>
    </section>
);
